// removed by extract-text-webpack-plugin
module.exports = {"AccordionList":"AccordionList-22f8fes2qhe35v1atzcr3gw5b9uktu7q1vub9xdn8smm2dy16vmntvdxq1v4tud37jxt8m3qx6avq5q3x683vksfpzmxtw9bxukxykr"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/AccordionList/AccordionList.module.scss
// module id = 1788
// module chunks = 0